module.exports = __webpack_public_path__ + "static/media/Mossburn-Springbank-opt.8e7c3b84.png";